<template>
  <div class="lh-homes imgs" style="background-image:url(img/e1.png)">
  	<div class="lh-logo1"><img src="img/logo-a.png" /><span>安全生产：{{logoText}}</span></div>
  	<div class="lh-treatment">
  		<div class="relative"><img src="img/e2.png" /></div>
  	</div>
    <Footer :footerData="footerData"></Footer>
  </div>
</template>

<script>
import Footer from '@/components/Footer'
export default{
	data(){
		return {
			footerData:{audioData:{total:'00:00',current:'00:00',percentage:0,icon:'icon-bofang',text:''},page:5,type:'culture'},
			logoText:'工伤——工伤保险待遇'
		}
	},
	created(e){
		var that=this;
	},
	mounted(e){
      var that=this;
      $(".lh-treatment").scroll(function(){
         var $this =$(this),
         viewH =$(this).height(),//可见高度
         contentH =$(this).get(0).scrollHeight,//内容高度
         scrollTop =$(this).scrollTop();//滚动高度
        //if(contentH - viewH - scrollTop <= 100) { //到达底部100px时,加载新内容
        if(scrollTop/(contentH -viewH)>=0.95){ //到达底部100px时,加载新内容
			     that.footerData={audioData:{total:'00:00',current:'00:00',percentage:0,icon:'icon-bofang',text:''},page:5,type:'culture',progress:true};
        	setTimeout(function(){
    				var tips='<div class="lh-end"><h3>消息<i class="iconfont icon-l-close tip-close"></i></h3><div class="cont">当前课件已学习完成，请学习下一个课件。</div><a href="javascript:;" id="Back">确定</a></div>';
    				if($('.lh-end').length<=0){
    					$('.lh-treatment').append(tips);
    				}
    			},2000);
    			$(document).on('click','.tip-close',function(){
    				$('.lh-end').remove();
    			});
    			//结束后返回
          document.addEventListener('UniAppJSBridgeReady', function () {  
          	  //自定义点击事件
              $(document).on('click','#Back', function (evt) {  
                console.log("aa")  
               	uni.navigateBack({})
              });  
          }); 
        }
      });
    },
	components:{
		Footer
	},
	methods:{

	}
}
</script>
